import { useQuery } from "@tanstack/react-query";
import { stockToFlowChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { StockToFlowQueryParams } from "@/types/indices";

export const useStockToFlowChart = (params?: StockToFlowQueryParams) => {
  return useQuery(stockToFlowChartQueryOptions(params));
};
